// import '../scss/main.scss'

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger)

import barba from '@barba/core';
import { Accordion } from './components/accordion.js'
import Slider from './components/slider.js'
import { Menu } from './components/menu.js'
import { win, setWin, setVh, setVw, isTouchDevice } from './utils/index.js'
import { animationEnter, animationLeave } from './animations/index.js';
import { Header } from './components/header.js'

const App = new function () {
	const body = document.body;

	this.init = () => {
		// Initial setup
		setWin()
		setVh()
		setVw()

		// If is Touch Device
		if (isTouchDevice) document.body.classList.add('is-touch-device')
		window.addEventListener('resize', this.onResize)

        Header.init();

		// Menu
		Menu.init()

		// Slider
		Slider.init();

		// Accordion //-- Must Be Before Inview Init --//
		Accordion.init();

		// Barba hooks
		barba.hooks.beforeEnter((data) => {
			const matches = data.next.html.match(/<body.+?class="([^""]*)"/i);
			document.body.setAttribute('class', (matches && matches.at(1)) ?? '');
            window.scrollTo(0, 0);
		});
		barba.hooks.beforeLeave(() => {
			anims.forEach(anim => {
				anim.scrollTrigger.kill();
				anim.pause(0).kill();
			});
		})
		barba.hooks.after(() => {
            // Header
            Header.init();

			// Menu
			Menu.init()

			// Slider
			Slider.init();

			// Accordion //-- Must Be Before Inview Init --//
			Accordion.init();

			initScrolling();
			// initShowHideHeader();
		})

		// Inview
		const anims = [];
		function initScrolling() {
			gsap.utils.toArray("[data-inview]").forEach(function (elem) {
				return (
					anims.push(gsap.to(elem, {
						scrollTrigger: {
							// markers:true,
							// scroller: document.querySelector('.tl-main-wrapper'),
							scroller: document.querySelector('.tl-layout'),
							trigger: elem,
							start: "top 95%",
							end: "bottom 70%",
							onEnter() {
								elem.classList.add('is-inview');
							},
						}
					}))
				)
			});
		}
		initScrolling();

        if (history && history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }

		// Barba Init
		barba.init({
            preventRunning: true,
			transitions: [
				{
					sync: false,
					name: 'general-transition',
                    beforeOnce({ next }) {
                        window.scrollTo(0, 0);
                        
                        const header = document.querySelector('.tl-header');
                        const boxBgMask = document.querySelector('.tl-page-header__mask');
                        const title = document.querySelector('.tl-page-header__title');
                        const mainText = document.querySelector('.tl-page-header__main-text');
                        const text = document.querySelector('.tl-page-header__text');
                        const project = document.querySelector('.tl-project');
                        
                        gsap.set(header, {
                            yPercent: -101
                        });
                        if (project) {
                            gsap.set(project, {
                                autoAlpha: 0,
                            })
                        } else {
                            gsap.set(boxBgMask, {
                                scaleY: 1,
                            });
                            gsap.set(title, {
                                autoAlpha: 0
                            });
                            gsap.set(mainText, {
                                autoAlpha: 0,
                                y: '2rem'
                            });
                            gsap.set(text, {
                                autoAlpha: 0,
                                y: '2rem'
                            });
                        }
					},
					once(data) {
                        const loader = document.querySelector('.js-c-loader');
                        
                        const header = document.querySelector('.tl-header');
                        const boxBgMask = document.querySelector('.tl-page-header__mask');
                        const boxBgImg = document.querySelector('.tl-page-header__bg-img img');
                        const title = document.querySelector('.tl-page-header__title');
                        const mainText = document.querySelector('.tl-page-header__main-text');
                        const text = document.querySelector('.tl-page-header__text');
                        const project = document.querySelector('.tl-project');

                        gsap.set(loader, {
                            autoAlpha: 0
                        });
                        const tl = gsap.timeline()
                            .addLabel('start')
                                .to(header, {
                                    yPercent: 0,
                                    duration: 1.0,
                                    ease: "power1.inOut",
                                }, 'start')

                                if (project) {
                                    tl.to(project, {
                                        autoAlpha: 1,
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start')
                                } else {
                                    tl.to(boxBgMask, {
                                        scaleY: 0,
                                        duration: 0.7,
                                        ease: "expo.out",
                                    }, 'start+=0.2')
                                    .to(mainText, {
                                        autoAlpha: 1,
                                        y: 0,
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start+=1.2')
                                    .to(text, {
                                        autoAlpha: 1,
                                        y: 0,
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start+=1.2')
                                    .to(boxBgImg, {
                                        autoAlpha: 1,
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start+=0.9')
                                    .to(title, {
                                        autoAlpha: 1,
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start+=1.0')
                                }

                             
					},
					async leave(data) {
						await new Promise(resolve => {
                            const currentDOM = data.current.container;
                            document.documentElement.classList.add('is-active-page-transition');

                            const boxBgMask = currentDOM.querySelector('.tl-page-header__mask');
                            const title = currentDOM.querySelector('.tl-page-header__title');
                            const mainText = currentDOM.querySelector('.tl-page-header__main-text');
                            const text = currentDOM.querySelector('.tl-page-header__text');
                            const sectionsWrapper = currentDOM.querySelector('.tl-sections-wrapper');
                            const archive = currentDOM.querySelector('.tl-archive');
                            const footer = currentDOM.querySelector('.tl-footer');
                            const project = currentDOM.querySelector('.tl-project');
                            

                            const tl = gsap.timeline()
                                .addLabel('start')
                                if (project) {
                                    tl.to(project, {
                                        autoAlpha: 0,
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start')
                                    .to(footer, {
                                        autoAlpha: 0,
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start')
                                } else {
                                    tl.to(title, {
                                        autoAlpha: 0,
                                        // y: '2rem',
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start')
                                    .to(boxBgMask, {
                                        scaleY: 1,
                                        // duration: 0.8,
                                        // ease: "expo.out",
                                        duration: 0.7,
                                        ease: "power2.inOut",
                                    }, 'start+=0.51')
                                    .to(mainText, {
                                        autoAlpha: 0,
                                        y: '2rem',
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start+=0.1')
                                    .to(text, {
                                        autoAlpha: 0,
                                        y: '2rem',
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start+=0.15')
                                    .to(footer, {
                                        autoAlpha: 0,
                                        duration: 0.5,
                                        ease: "power1.inOut",
                                    }, 'start')
                                }
                                    
                                    if (sectionsWrapper) {
                                        tl.to(sectionsWrapper, {
                                            autoAlpha: 0,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start')
                                    }
                                    if (archive) {
                                        tl.to(archive, {
                                            autoAlpha: 0,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start')
                                    }


                                tl.eventCallback("onComplete", () => {
                                    resolve();
                                });

						});
					},
                    afterLeave(data){
                        const currentDOM = data.next.container;

                        const boxBgMask = currentDOM.querySelector('.tl-page-header__mask');
                        const title = currentDOM.querySelector('.tl-page-header__title');
                        const mainText = currentDOM.querySelector('.tl-page-header__main-text');
                        const text = currentDOM.querySelector('.tl-page-header__text');
                        const footer = currentDOM.querySelector('.tl-footer');
                        const sectionsWrapper = currentDOM.querySelector('.tl-sections-wrapper');
                        const archive = currentDOM.querySelector('.tl-archive');
                        const project = currentDOM.querySelector('.tl-project');

                        if (project) {
                            gsap.set(project, {
                                autoAlpha: 0,
                            })
                            gsap.set(footer, {
                                autoAlpha: 0,
                            })
                        } else {
                            gsap.set(title, {
                                autoAlpha: 0,
                            })
                            gsap.set(boxBgMask, {
                                scaleY: 1,
                            })
                            gsap.set(mainText, {
                                autoAlpha: 0,
                                y: '2rem',
                            })
                            gsap.set(text, {
                                autoAlpha: 0,
                                y: '2rem',
                            })
                            gsap.set(footer, {
                                autoAlpha: 0,
                            })
                        }
                        
                        
                        if (sectionsWrapper) {
                            gsap.set(sectionsWrapper, {
                                autoAlpha: 0,
                            })
                        }
                        if (archive) {
                            gsap.set(archive, {
                                autoAlpha: 0,
                            })
                        }
                        
                        data.current.container.remove();
                    },
					async enter(data) {
						await new Promise(resolve => {
                            const currentDOM = data.next.container;

                            const boxBgMask = document.querySelector('.tl-page-header__mask');
                            const title = currentDOM.querySelector('.tl-page-header__title');
                            const mainText = currentDOM.querySelector('.tl-page-header__main-text');
                            const text = currentDOM.querySelector('.tl-page-header__text');
                            const footer = currentDOM.querySelector('.tl-footer');
                            const sectionsWrapper = currentDOM.querySelector('.tl-sections-wrapper');
                            const archive = currentDOM.querySelector('.tl-archive');
                            const project = currentDOM.querySelector('.tl-project');

                            const tl = gsap.timeline()
                                .addLabel('start')
                                    if (project) {

                                        tl.to(project, {
                                            autoAlpha: 1,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start')
                                        .to(footer, {
                                            autoAlpha: 1,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start')

                                    } else {
                                        
                                        tl.to(title, {
                                            autoAlpha: 1,
                                            y: 0,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start+=0.9')
                                        .to(boxBgMask, {
                                            scaleY: 0,
                                            duration: 0.7,
                                            ease: "expo.out",
                                            // ease: "power2.inOut",
                                        }, 'start')
                                        .to(mainText, {
                                            autoAlpha: 1,
                                            y: 0,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start+=1.2')
                                        .to(text, {
                                            autoAlpha: 1,
                                            y: 0,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start+=1.2')
                                        .to(footer, {
                                            autoAlpha: 1,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start')

                                    }

                                    if (sectionsWrapper) {
                                        tl.to(sectionsWrapper, {
                                            autoAlpha: 1,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start');
                                    }
                                    if (archive) {
                                        tl.to(archive, {
                                            autoAlpha: 1,
                                            duration: 0.5,
                                            ease: "power1.inOut",
                                        }, 'start');
                                    }

                                tl.eventCallback("onComplete", () => {
                                    console.log('onComplete')
                                    document.documentElement.classList.remove('is-active-page-transition');
                                    resolve();
                                });

						});
					},

				}, 
             
                // {
				// 	sync: false,
				// 	name: 'general-transition',
				// 	once({ next }) {
				// 		gsap.from(next.container, { autoAlpha:0, duration: .7, ease: 'none' })
				// 	},
				// 	leave(data) {
				// 		animationLeave(data.current.container)
				// 	},
				// 	enter({ next }) {
				// 		animationEnter(next.container)
				// 	},
				// },
			],
		});
  	}

	this.onResize = () => {
		setWin()
		setVh()
		setVw()
	}

}

window.addEventListener('load', App.init)